import React from 'react';
import './App.scss';
import { Banner } from 'components/banner/Banner';
import { Header } from 'components/header/Header';
import { Card } from 'components/Card/Card';
import { Footer } from 'components/footer/Footer';
import { homeCardList } from 'helper/data/home';


function App() {
  return (
    <>
    <Header />
    <div className="App">
     <Banner />
     <div className='container'>
     <div className='vision-top-text'>
      <h1 className="vision-heading"><strong>We enable everyone to communicate in any language</strong></h1>
      <p className="vision-description">Super translate enables travelers, students, business professionals, employers and medical staff to read, write and speak in over 100 languages, anywhere in the world.</p>
     </div>
      {homeCardList.map((card, i) => (
        <Card icon={card.centerImg} isImgLeft={(i+1) % 2 === 0} key={card.desc} title={card.title} des={card.desc} img={card.img} />
      ))}
     </div>
     <div className='container privacy-frame'>
       <div className='privacy-img-frame'>
        <img src={require("assets/img/privacy_artwork_icon2x.png")} alt="" />
        <div className='privacy-bg'></div>
       </div>
       <div className='privacy-des-frame'>
         <h1 className="title"><strong>Privacy is at the core of everything we do</strong></h1>
         <p className="text-alignment---center">For us here at iTranslate privacy is one of our most important core values. Every product we develop and ship to you, our customer, is designed to keep your data safe. In a world of increasing complexity we firmly believe your data is yours and yours alone. We take our responsibility and your faith to protect this very seriously.<br/><br/>
            <a href="https://sites.google.com/view/superprivategallery/home/privacy-policy" target="_blank" className="link" rel="noreferrer">Privacy Policy</a>
          </p>
       </div>
     </div>
     <div className='container world-map'>
       <div className='word-map-text-frame'>
       <h2><strong>Available<br />everywhere</strong></h2>
          <p className="description">No matter what device you’re on – we’ve got you covered! iTranslate is your perfect travel companion and is available on a large variety of platforms and devices.</p>
       </div>
       <div className='map-img'></div>
     </div>
    </div>
    <Footer />
    </>
  );
}

export default App;
